// extracted by mini-css-extract-plugin
export default {"container":"faqs_container__A7KIx","heading":"faqs_heading__2Rqdc"};